export default defineAppConfig({
  ui: {
    primary: 'telegram-cards',
    gray: 'neutral',
  }
})
